import { Box, Flex, Skeleton, Typography } from '@iheartjane/reefer';

import { useKioskSpacing, usePdpModalClose } from '@jane/kiosk/hooks';

import { Modal } from '../Modal';
import { ModalHeader } from '../ModalHeader/ModalHeader';

const imageSize = '360px';

export const ProductDetailSkeleton = () => {
  const { defaultSpacing, getKioskSpacing, isIpad } = useKioskSpacing();
  const { onModalClose, pdpDepth } = usePdpModalClose();

  return (
    <Modal
      appId="root"
      contentLabel="Product Detail"
      onRequestClose={onModalClose}
      open
      overflow="scroll"
      overlayClose
    >
      <ModalHeader nested={Number(pdpDepth) > 1} onRequestClose={onModalClose}>
        <Flex alignItems="center" grow={1} justifyContent="space-between">
          <Typography variant={isIpad ? 'h3-semibold' : 'h2-semibold'}>
            Product details
          </Typography>
          <Box>
            <Skeleton animate>
              <Skeleton.Bone
                width="180px"
                height={isIpad ? '40px' : '48px'}
                borderRadius="sm"
              />
            </Skeleton>
          </Box>
        </Flex>
      </ModalHeader>
      <Modal.Content padding={false}>
        <Skeleton animate>
          <Flex flexDirection="column" p={defaultSpacing}>
            <Flex flexDirection="row" mb={defaultSpacing}>
              {/* Product image */}
              <Skeleton.Bone
                width={imageSize}
                height={imageSize}
                borderRadius="lg"
              />

              {/* Product info */}
              <Flex flexDirection="column" pl={32} grow={1}>
                {/* Brand */}
                <Skeleton.Bone width="120px" mb={8} />
                {/* Category / Subcategory */}
                <Skeleton.Bone width="180px" mb={8} />
                {/* Product name */}
                <Skeleton.Bone
                  width="260px"
                  height={isIpad ? '28px' : '32px'}
                  mb={8}
                />
                {/* Price */}
                <Skeleton.Bone
                  width="100px"
                  height={isIpad ? '28px' : '32px'}
                  mb={getKioskSpacing(32, 16)}
                />
                {/* Product tag (e.g. Indica) */}
                <Skeleton.Bone width="80px" height="32px" borderRadius="sm" />
              </Flex>
            </Flex>

            {/* Description section */}
            <Box
              border="transparent-black-five"
              borderRadius="lg"
              p={defaultSpacing}
              mb={24}
            >
              <Skeleton.Bone
                width="120px"
                height={isIpad ? '20px' : '24px'}
                mb={getKioskSpacing(24, 8)}
              />
              <Skeleton.Bone width="100%" mb={8} />
              <Skeleton.Bone width="100%" mb={8} />
              <Skeleton.Bone width="60%" />
            </Box>
          </Flex>
        </Skeleton>
      </Modal.Content>
    </Modal>
  );
};
